
// import React from 'react';

// const Idcard = ({ name, college, semester, studentid, profileimage }) => {
//     return (
//         <div style={styles.card}className='bg-red-100 shadow-lg p-4 rounded-lg border-2 border-gray-300'>
//             <img src={profileimage} alt="profile" style={styles.photo} />
//             <p >Name: {name}</p>
//             <p>College: {college}</p>
//             <p>Semester: {semester}</p>
//             <p>Student ID: {studentid}</p>
//         </div>
//     );
// };

// const styles = {
 
//     // card: {
//     //     padding: '10px',
//     //     justifyContent:'center',
//     //     textAlign: 'left',
//     //     border: '1px solid black',
//     //     borderRadius: '10px',
//     //     width: '200px',
//     //     fontFamily: 'Arial',
     
//     //     boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     // },
//     photo: {
//         width: '100px',
//         height: '100px',
//         objectFit: 'cover',
//         margin: '0 auto',
//         // borderRadius: '50%',
//         display: 'block',
//         marginBottom: '10px', 

//     }
// };

// export default Idcard;


import React from 'react';

const Idcard = ({ name, DOB, Address, college, semester, studentid, profileimage, Validity }) => {
    return (
        <div className="bg-red-50 shadow-lg  rounded-lg border-2 border-gray-300 w-90 p-2">
            <header className='justify-center items-center text-center  flex flex-row '>
                <img src="image/tulogo.jpeg" alt="TU Logo" className="w-16 h-16 mx-auto mt-4" />
                <h1 className="text-red-800 uppercase font-bold ">Tribhuvan University</h1>
                <img src="/image/pklogo.jpeg" alt="PKMC Logo" className="w-16 h-16 mx-auto mt-2" />
            </header>
            <p className='text-center font-bold text-blue-800 p-2 '>Padmakanya Multiple Campus</p>
            <p className='text-center'>Estd.2008 B.S. (1951 A.D)</p>
            <p className='text-sm  pb-2'>Bagbazar,Kathmandu,Nepal | Tel:5321712, 5324149</p>
               <div className="text-left">
                     <h1 className="text-white text-center font-semibold uppercase bg-red-800 border rounded-lg ">Student's ID Card</h1>
                        <p className=' text-center'>Bsc.Csit 7th & 8th sem</p>
                        </div>
        <div className=' p-4 mx-auto flex justify-center items-center'>
            <img  src={profileimage} alt="profile" className='w-24 h-24 mx-10 ' />
            
        </div>
        <div className='text-left  color-gray-800 '>
            <p><span className='text-blue-600'> Name:</span> {name}</p>
            <p><span className='text-blue-600'>Date of Birth:</span> {DOB}</p>
            <p><span className='text-blue-600'>Address:</span> {Address}</p>
            <p><span className='text-blue-600'>College: </span>{college}</p>
            <p><span className='text-blue-600'>Semester: </span>{semester}</p>
            <p><span className='text-blue-600'>Student ID:</span> {studentid}</p>
            <p><span className='text-blue-600'>Validity:</span> {Validity}</p>
        </div>
        <footer className='  text-center text-blue-700  bg-blue-500 rounded-b-lg mt-6'>
            <p className="text-white font-sm  ">Website:pkmc.tu.edu.np</p>
            </footer>
        </div>
    );
};


export default Idcard;